import { useEffect } from 'react';

import { useActiveTeamId } from '../../store/Team/useTeamStore';
import { setGTMActiveTeam } from '../../utils/gtm/userProperties';

// Pushes the active team to GTM whenever the user switches teams, so analytics
// events can be attributed per team. Mount once in the authenticated layout.
export const useGTMActiveTeam = () => {
  const activeTeamId = useActiveTeamId();

  useEffect(() => {
    if (activeTeamId) {
      setGTMActiveTeam(activeTeamId);
    }
  }, [activeTeamId]);
};
